import Vue from "vue";
import axios from "axios";

// Acesso do administrador logado (perfil configurado em Administracao > Perfis):
// vem de /api/admin/me/access uma vez por login e serve ao menu, as rotas e as
// telas. A API confere o mesmo perfil (403 quando falta permissao).
// Areas = chaves do menu (`path`); acoes = view, create, edit, delete e as
// acoes especificas do catalogo (chaves com ponto, ex.: "rma.review").
// "Profiles" (tela de perfis) e so para acesso total.

const METHOD_ACTIONS = { GET: "view", POST: "create", PUT: "edit", PATCH: "edit", DELETE: "delete" };

const state = Vue.observable({ token: null, loaded: false, is_super: false, profile: null, permissions: {}, capabilities: [], areas: [] });
let pending = null;

function currentToken() {
  try {
    return localStorage.getItem("token");
  } catch (error) {
    return null;
  }
}

function apply(content) {
  state.is_super = !!content.is_super;
  state.profile = content.profile || null;
  state.permissions = content.permissions || {};
  state.capabilities = content.capabilities || [];
  state.areas = content.areas || [];
  state.loaded = true;
}

function reset() {
  state.token = null;
  state.loaded = false;
  state.is_super = false;
  state.profile = null;
  state.permissions = {};
  state.capabilities = [];
  state.areas = [];
  pending = null;
}

// Carrega uma vez por token (novo login ou outro usuario recarrega).
async function load() {
  const token = currentToken();
  if (!token) {
    reset();
    return state;
  }
  if (state.loaded && state.token === token) return state;
  if (pending && state.token === token) return pending;
  state.token = token;
  pending = axios.get("/api/admin/me/access")
    .then((result) => {
      apply(result.data.content);
      return state;
    })
    .catch((error) => {
      pending = null;
      state.loaded = false;
      throw error;
    });
  return pending;
}

// Acao especifica ("rma.review", "event.decide"...): vale em qualquer tela.
function hasCapability(key) {
  return state.is_super || state.capabilities.includes(key);
}

function can(area, action = "view") {
  if (action && action.includes(".")) return hasCapability(action);
  if (!area) return true;
  if (state.is_super) return true;
  if (area === "Profiles") return false;
  const flags = state.permissions[area];
  return !!(flags && flags[action]);
}

// Area da rota do backoffice (nome da rota). Sem area: tela livre (inicio, login).
function areaOfRoute(name) {
  if (!name) return null;
  if (name === "Profiles") return "Profiles";
  const area = state.areas.find((item) => (item.routes || [item.key]).includes(name));
  return area ? area.key : null;
}

function actionOfMethod(method) {
  return METHOD_ACTIONS[String(method || "GET").toUpperCase()] || "view";
}

export default { state, load, reset, can, hasCapability, areaOfRoute, actionOfMethod };
